/**
 * @namespace helpers
 */

/**
 * Helper functions for Date
 *
 * @module date
 * @memberof helpers
 * @see helpers
 */

import moment from 'moment'

/**
 * stringToDate for time
 *
 * @function
 * @param  {string} utcStr
 * @param  {string} mode
 * @return {Date} time
 */
export const timeStringToDate = (utcStr, mode = 'no') => {
  const time = new Date()
  if (utcStr) {
    const timezoneOffset = parseInt(window.localStorage.getItem('timezoneOffset'))
    const hours = utcStr ? +utcStr.split(':')[0] : 0
    const minutes = utcStr ? +utcStr.split(':')[1] : 0
    const seconds = (utcStr && utcStr.split(':').length > 2) ? +utcStr.split(':')[2] : 0
    time.setHours(hours + timezoneOffset)
    time.setMinutes(minutes)
    time.setSeconds(seconds)
  } else {
    switch (mode) {
      case 'startOfDay' :
        time.setHours(0)
        time.setMinutes(0)
        time.setSeconds(0)
        break
      case 'endOfDay':
        time.setHours(23)
        time.setMinutes(59)
        time.setSeconds(0)
        break
    }
  }
  return time
}

/**
 * format Date by timezone for time
 *
 * @function
 * @param  {number} datems
 * @param toUtc
 * @return {any} date
 */
export const formatDateByTimezone = (datems, toUtc = true) => {
  const date = moment(datems)
  const browserOffset = parseInt(moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('Z'))
  const timezoneOffset = parseInt(window.localStorage.getItem('timezoneOffset'))
  if (toUtc) {
    return date.add(browserOffset - timezoneOffset, 'hours').utc()
  } else {
    return date.add(timezoneOffset - browserOffset, 'hours')
  }
}
/**
 * Parse an "HH:MM:SS" duration string into a Date carrying that time-of-day.
 *
 * Timezone-free (unlike {@link timeStringToDate}) because skip-segment values
 * are content-relative offsets, not clock times. Mirrors the `formatLength`
 * helper used for the content Length field so the same uib-timepicker control
 * renders them. A null/empty input yields 00:00:00.
 *
 * @function
 * @param  {string} [str] - "HH:MM:SS"
 * @return {Date}
 */
export const durationStringToDate = (str) => {
  const hours = str ? +str.split(':')[0] : 0
  const minutes = str ? +str.split(':')[1] : 0
  const seconds = (str && str.split(':').length > 2) ? +str.split(':')[2] : 0
  const date = new Date()
  date.setHours(hours, minutes, seconds, 0)
  return date
}

/**
 * Format a Date's time-of-day into an "HH:MM:SS" duration string (timezone-free).
 * Inverse of {@link durationStringToDate}. Returns null for a falsy date.
 *
 * @function
 * @param  {Date} [date]
 * @return {string|null} "HH:MM:SS"
 */
export const dateToDurationString = (date) => {
  if (!date) {
    return null
  }
  const pad = (n) => ('0' + n).slice(-2)
  return pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds())
}

/**
 * format Date without utc
 *
 * @function
 * @param  {Date} date
 * @param {string} format
 * @return {any} date
 */
export const dateAsUTC = (date, format) => {
  if (date) {
    return moment.utc(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`).format(format)
  }
  return ''
}
